import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * StepUpPanel — "Continue with passkey" / "Use a recovery code" (NEXUS-586 phase 3).
 * On success the new access token goes to the host (provider onAccessToken), then onDone.
 */
import { useState } from 'react';
import { useNexusAdmin } from '../provider.js';
import { useNexusFetch } from '../api.js';
import { mfaErrorText, stepUpWithPasskey, stepUpWithRecoveryCode } from '../mfa.js';
export function StepUpPanel({ onDone, intro }) {
    const fetcher = useNexusFetch();
    const { onAccessToken } = useNexusAdmin();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [useCode, setUseCode] = useState(false);
    const [code, setCode] = useState('');
    const [left, setLeft] = useState(null);
    const finish = (token) => {
        onAccessToken?.(token);
        onDone?.();
    };
    const passkey = async () => {
        setBusy(true);
        setError(null);
        try {
            finish((await stepUpWithPasskey(fetcher)).accessToken);
        }
        catch (e) {
            setError(mfaErrorText(e));
        }
        finally {
            setBusy(false);
        }
    };
    const recovery = async (e) => {
        e.preventDefault();
        if (!code.trim())
            return;
        setBusy(true);
        setError(null);
        try {
            const r = await stepUpWithRecoveryCode(fetcher, code.trim());
            setLeft(r.recoveryCodesRemaining);
            finish(r.accessToken);
        }
        catch (x) {
            setError(mfaErrorText(x));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("div", { children: [_jsx("p", { className: "text-muted small", children: intro ?? 'Platform admin access needs a second step. Confirm it is you with Face ID, Touch ID or your security key.' }), error && _jsx("div", { className: "alert alert-danger py-2 small", role: "alert", children: error }), left !== null && left <= 3 && (_jsxs("div", { className: "alert alert-warning py-2 small", children: ["Only ", left, " recovery code", left === 1 ? '' : 's', " left \u2014 make new ones under Profile \u2192 Security."] })), !useCode ? (_jsxs("div", { className: "d-grid gap-2", children: [_jsx("button", { type: "button", className: "btn btn-primary", onClick: () => void passkey(), disabled: busy, children: busy ? 'Waiting for your passkey…' : 'Continue with passkey' }), _jsx("button", { type: "button", className: "btn btn-link btn-sm", onClick: () => { setUseCode(true); setError(null); }, disabled: busy, children: "Use a recovery code" })] })) : (_jsxs("form", { onSubmit: (e) => void recovery(e), children: [_jsx("label", { className: "form-label small", htmlFor: "stepup-code", children: "Recovery code" }), _jsx("input", { id: "stepup-code", className: "form-control font-monospace mb-2", autoComplete: "one-time-code", autoFocus: true, placeholder: "XXXXX-XXXXX", value: code, onChange: (e) => setCode(e.target.value), maxLength: 20 }), _jsxs("div", { className: "d-grid gap-2", children: [_jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy || !code.trim(), children: busy ? 'Checking…' : 'Continue' }), _jsx("button", { type: "button", className: "btn btn-link btn-sm", onClick: () => { setUseCode(false); setError(null); }, disabled: busy, children: "Use my passkey instead" })] })] }))] }));
}
//# sourceMappingURL=StepUpPanel.js.map